import { createSlice } from '@reduxjs/toolkit';
import { ICategory } from 'shared/common/types/categories';

const initialState: ICategory[] = [];

/* istanbul ignore next */
const typesSlice = createSlice({
  initialState,
  name: 'types',
  reducers: {},
});

export const { reducer: typesReducer } = typesSlice;
